import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Globe = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Globe_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm-6.71-6A7.001 7.001 0 0 1 1 8c0-.695.101-1.366.29-2h3.326a17.361 17.361 0 0 0-.003 4H1.29Zm.384 1a7.017 7.017 0 0 0 4.463 3.75c-.613-.896-1.097-2.213-1.376-3.75H1.674Zm4.105 0c.163.84.391 1.594.663 2.222.285.656.6 1.129.898 1.423.295.29.517.355.66.355.143 0 .365-.065.66-.355.299-.294.613-.767.898-1.423.272-.628.5-1.382.663-2.222H5.78Zm5.46 0c-.279 1.537-.763 2.854-1.376 3.75A7.018 7.018 0 0 0 14.326 11H11.24Zm3.471-1h-3.324a17.318 17.318 0 0 0-.002-4h3.326c.189.634.29 1.305.29 2 0 .695-.101 1.366-.29 2Zm-4.33 0H5.62c-.078-.633-.12-1.3-.12-1.99 0-.695.043-1.37.123-2.01h4.754a16.327 16.327 0 0 1 .002 4ZM4.764 5H1.674a7.017 7.017 0 0 1 4.468-3.75C5.53 2.144 5.044 3.462 4.765 5Zm1.678-2.212c-.27.626-.498 1.377-.66 2.212h4.435a10.901 10.901 0 0 0-.661-2.212c-.285-.66-.6-1.135-.898-1.431C8.363 1.064 8.14 1 8 1c-.141 0-.363.064-.659.357-.299.296-.613.772-.898 1.431ZM11.235 5h3.091a7.017 7.017 0 0 0-4.468-3.75c.612.895 1.098 2.213 1.377 3.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Globe_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Globe;